// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "input-1tIvX";
export { _1 as "__esModule", _2 as "input" }
export default { "__esModule": _1, "input": _2 }
